import { createContext } from 'react'

import { PrebidModulesContextType } from './types'

export const PrebidModulesContext = createContext<PrebidModulesContextType>(
  {} as PrebidModulesContextType,
)
